import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function UserSidebarDataRow({ dataRow, isWithTooltip = false }) {
  return (
    <div className={`user-data__row ${isWithTooltip ? 'user-data__row--interactive' : ''}`}>
      <div className="user-data__data-title">
        <span className="icon-holder">
          {dataRow.icons.map((icon, i) => (
            <Icon key={`user-data-icon-${i}`} type={[icon.type, icon.icon]} />
          ))}
        </span>
        <span><small>{dataRow.title}</small></span>
      </div>
      <div className="user-data__data">
        <span className="text-semibold"><small>{dataRow.data}</small></span>
        {isWithTooltip && (
          <Icon type={['fas', 'caret-down']} notSpaced />
        )}
      </div>
    </div>
  )
}

UserSidebarDataRow.propTypes = {
  dataRow: PropTypes.shape({
    icons: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    data: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.element,
      PropTypes.string,
    ]),
  }).isRequired,
  isWithTooltip: PropTypes.bool,
}

export default UserSidebarDataRow
